import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environmentEmpleados } from '@environments/environment';

import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class HistoryService {
    constructor(private http: HttpClient) { }

    getHistoryPage(page) {
        let json = {
            Page : page
        }
        return this.http.post<any>(`${environmentEmpleados.apiUrl}/History/GetCurrentUserPaged`,json);
    }

   
}